import { FC } from 'react';
import { LandingCategoryBannerStoryblok } from 'storyblok-types';
import { Container } from 'atoms/Container';
import { Image } from 'atoms/Image/Image';
import { Link } from 'atoms/Link/Link';
import { Title } from 'atoms/Typography/Typography';
import styles from './LandingCategoryBanner.module.css';

export const LandingCategoryBanner: FC<{
  blok: LandingCategoryBannerStoryblok;
}> = ({ blok }) => {
  const { landingCategoryBanner } = blok;

  return (
    !!landingCategoryBanner?.length && (
      <Container className={styles.root} key={blok._uid}>
        {landingCategoryBanner?.map((item) => {
          return (
            <>
              <Link
                key={item._uid}
                href={item.link}
                className={styles.item}
                style={{
                  backgroundColor: item?.textBackground?.color,
                }}
              >
                <Image
                  src={item.image.filename}
                  alt={item.image?.alt}
                  className={styles.img}
                />
                {item.text && (
                  <Title
                    type="lg"
                    style={{
                      color: item?.textColor?.color,
                    }}
                    className={styles.text}
                  >
                    {item.text}
                  </Title>
                )}
              </Link>
            </>
          );
        })}
      </Container>
    )
  );
};
